module.exports = __webpack_public_path__ + "img/unlock.57190f55.svg";